<template>
  <div class="mt-2">
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Resale Property List' }"
        id="resalepropertylist"
        class="input-text-size"
      >
      Resale Property List
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Bidder Registration' }"
        id="bidderregistration"
        class="input-text-size"
      >
      Bidder Registration
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Day of Sale' }"
        id="dayofsale"
        class="input-text-size"
      >
      Day of Sale
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Reports' }"
        id="resalereports"
        class="input-text-size"
      >
      Reports
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import '../../../../assets/style.css';

export default {
  name: 'JuneResale',
  components: {
  },
};
</script>
